import { useLocation } from "react-router-dom";
import { useIRCContext } from "./IRCContext";
import LockScreen from "./pages/LockScreen";

// Always visible regardless of lock state (as per product requirement)
const ALWAYS_VISIBLE = ["solution", "disclaimer", "thread", "appendix"];

// Funding is accessible during fee_locked so the Contact user can pay
const FEE_PAYMENT_PATH = "funding";

const IRCPageGuard = ({ children }: { children: React.ReactNode }) => {
  const { lockState } = useIRCContext();
  const { pathname } = useLocation();

  if (lockState === "unlocked") return <>{children}</>;

  const segment = pathname.split("/").pop() ?? "";
  const alwaysVisible = ALWAYS_VISIBLE.some((p) => segment.includes(p));
  if (alwaysVisible) return <>{children}</>;

  // During fee_locked the Contact needs to reach the funding page to pay
  if (lockState === "fee_locked" && segment.includes(FEE_PAYMENT_PATH)) return <>{children}</>;

  return <LockScreen />;
};

export default IRCPageGuard;
